import styled from 'styled-components';

import Link from '@/components/Link';
import { getTheme } from '@/constants/theme';
import PhoneIcon from '@/assets/svg/phone-filled.svg';
import { getPhoneLink } from '@/utils/common';
import { googleEvent } from '@/utils/events';
import useSettingItem from '@/hooks/useSettingItem';
import { usePhoneNumber } from '@/hooks/usePhoneNumber';

import { componentColors } from '../../constants';

interface PhoneLinkProps {}

const PhoneLink = (props: PhoneLinkProps) => {
  const theme = getTheme();
  const phone = usePhoneNumber();

  const phoneClickGoogleEvent = useSettingItem('PHONE_CLICK_GOOGLE_EVENT');

  const onPhoneClick = () => {
    if (phoneClickGoogleEvent) {
      googleEvent(phoneClickGoogleEvent);
    }
  };

  switch (theme) {
    case 'b2b':
    case 'sollers':
      return (
        <InfoNumber to={getPhoneLink(phone)} onClick={onPhoneClick}>
          <PhoneIcon />
        </InfoNumber>
      );
    default:
      return null;
  }
};

export default PhoneLink;

const InfoNumber = styled(Link)`
  position: relative;
  font-size: 16px;
  line-height: 130%;
  white-space: nowrap;
  border: 1px solid #d3dadf;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 34px;
  height: 34px;
  margin-left: auto;
  right: 20px;

  & path {
    fill: ${componentColors.headerMobilePhone};
    stroke: ${componentColors.headerMobilePhone};
  }
`;
